import React from "react";
import "./ApproachSection.css";

import TopRightLeaf from "../Assets/grass-top-right.png";
import BottomLeftLeaf from "../Assets/grass-bottom-left.png";

import Icon1 from "../Assets/Approach-icon1.png";
import Icon2 from "../Assets/Approach-icon2.png";
import Icon3 from "../Assets/Approach-icon3.png";

const ApproachSection = () => {
  return (
    <section className="approachSection">
      {/* Decorative images */}
      <img src={TopRightLeaf} alt="leaf" className="approachTopRightImg" />
      <img src={BottomLeftLeaf} alt="leaf" className="approachBottomLeftImg" />

      {/* Content */}
      <div className="approachContentWrapper">

        <h2 className="approachTitle anim anim-bottom">Our Approach</h2>
        <h3 className="approachSubTitle anim anim-bottom">Empowering a Greener Generation”</h3>
        <p className="approachTagline anim anim-bottom">Crafting Dairy with Care and Purpose</p>

        {/* Icon Row */}
        <div className="approachIconsRow anim anim-top">
          <div className="approachIconBox">
            <img src={Icon1} alt="Step 1" />
          </div>
          <div className="approachIconBox">
            <img src={Icon2} alt="Step 2" />
          </div>
          <div className="approachIconBox">
            <img src={Icon3} alt="Step 3" />
          </div>
        </div>

        <a href="/products" className="approachDiscoverBtn anim anim-bottom">
  Discover the Vangal →
</a>
      </div>
    </section>
  );
};

export default ApproachSection;
